import { defineComponent as u, mergeModels as d, useModel as m, provide as r, computed as i, createElementBlock as n, openBlock as c, mergeProps as g, unref as o, renderSlot as f } from "vue";
import t from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/ToggleGroup/toggle-group.js";
import { useOUIAProps as y } from "../../helpers/ouia.js";
const G = Symbol("ToggleGroupDisabledKey"), S = Symbol("ToggleGroupSelectionKey"), P = /* @__PURE__ */ u({
  name: "PfToggleGroup",
  __name: "ToggleGroup",
  props: /* @__PURE__ */ d({
    compact: { type: Boolean },
    disabled: { type: Boolean },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  }, {
    modelValue: { default: null },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(l) {
    const e = l, s = y({ id: e.ouiaId, safe: e.ouiaSafe }), p = m(l, "modelValue");
    return r(G, i(() => e.disabled)), r(S, p), (a, b) => (c(), n("div", g(o(s), {
      class: [o(t).toggleGroup, { [o(t).modifiers.compact]: a.compact }],
      role: "group"
    }), [
      f(a.$slots, "default")
    ], 16));
  }
});
export {
  G as ToggleGroupDisabledKey,
  S as ToggleGroupSelectionKey,
  P as default
};
